<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchDetailHandle">
				<c-form ref="searchForm">
					<c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="客户名称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="业务员姓名" name="salesman_realname"></c-form-item>
					<c-form-item type="input" label="订单号" name="tran_number"></c-form-item>
					<c-form-item type="datetime" label="挂账时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="checkbox" label="账单状态" name="tran_state" :options="transState"></c-form-item>
					<c-form-item type="checkbox" label="" name="exp_flag" :options="[{name: '已逾期',value: 1}]"></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
				<c-button power="b_member_account_credit_info_export" @click="exportData()" icon="export">导出账单明细</c-button>
				<c-button power="b_member_account_credit_info_repay" @click="batchHk()" >批量还款</c-button>
			</m-operate>
			<c-table ref="detailTable" code="">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="tran_state"
					width="130"
				>
					<template v-slot="{data}">
						<span v-if="data.tran_state==0">
							<span style="color:#000">{{stateName[data.tran_state]}}</span>
							<span style="color:#bbb" v-if="data.order_state == 2">(未发货)</span>
							<span style="color:#f55" v-else-if="data.invoice_state == 1">(未开票)</span>
						</span>
						<span v-if="data.tran_state==1">
							<span style="color:#182eff">{{stateName[data.tran_state]}}</span>
							<span style="color:#f55" v-if="data.exp_flag == 1">(已逾期)</span>
						</span>
						<span v-if="data.tran_state==2"><span style="color:#182eff">{{stateName[data.tran_state]}}</span></span>
						<span v-if="data.tran_state==3"><span style="color:green">{{stateName[data.tran_state]}}</span></span>
						<span v-if="data.tran_state==4"><span style="color:#999">{{stateName[data.tran_state]}}</span></span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="订单号"
					name="tran_number"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="客户电话"
					name="user_manage_mobilephone"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="客户名称"
					name="nick_name"
					width ="130"
				></c-table-column>
				
				<c-table-column
					label="业务员"
					name="salesman_realname"
				>
				</c-table-column>
				
				<c-table-column
					label="下单时间"
					name="order_create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="审核（挂账）时间"
					name="tran_date"
          width="160"
				></c-table-column>
				
				<c-table-column
					label="交易金额"
					name="tran_amount"
					width="100"
				>
					<template v-slot="{data}">
						￥{{parseFloat(data.tran_amount).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="已出账金额"
					name="out_account_amount"
					width="100"
				>
					<template v-slot="{data}">
              <span v-if="data.out_account_amount && data.out_account_amount>0">￥{{parseFloat(data.out_account_amount + data.return_amount).toFixed(2)}}</span>
              <span v-else>--</span>
            </template>
				</c-table-column>

				<c-table-column
					label="已退款金额"
					name="refund_amount"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.tran_state==4">￥{{parseFloat(data.refund_amount + data.return_amount).toFixed(2)}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="已还款金额"
					name="repay_amount"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.tran_state==0 || data.tran_state==4">--</span>
						<span v-else>￥{{parseFloat(data.repay_amount).toFixed(2)}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="当前欠款"
					name="debt_amount"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.tran_state==0 || data.tran_state==4">--</span>
						<span v-else>￥{{parseFloat(data.tran_amount - data.refund_amount - data.return_amount - data.repay_amount).toFixed(2)}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="出账时间"
					name="bill_date"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.tran_state==0 || data.tran_state==4">--</span>
						<span v-else>{{data.bill_date}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="逾期时间"
					name="exp_date"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.tran_state==1 && data.exp_flag == 0">{{data.exp_date}}</span>
						<span style="color:red" v-if="data.tran_state==1 && data.exp_flag == 1">{{data.exp_date}}</span>
						<span v-if="data.tran_state!=1">--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
            <c-table-button power="b_member_account_credit_info_view" @click="navigateTo(`/member_account_credit_info_detail/${data.id}`)">查看</c-table-button>
						<c-table-button power="b_member_account_credit_info_repay" v-if="(data.tran_amount - data.refund_amount - data.return_amount - data.repay_amount) > 0 && (data.tran_state == 1 || data.tran_state == 2)" @click="onHk(data)">
              还款
            </c-table-button>
            <c-table-button v-if="data.repay_amount > 0" @click="showRepayRecord(data)">还款记录</c-table-button>
          </template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="voucherConf" title="还款确认信息" button-name="确认还款" width="600" @resolve="submitHk">
			<c-form  ref="repayForm">
			<div class="payment">
				<p v-if="is_bath == 1" v-html="text_msg"></p>
				<c-form-item type="number" v-if="is_bath == 0" v-model="repayMoney" :limit="this.max_repayMoney" decimal="2" label="还款金额" ></c-form-item>
				<c-form-item type="radio" v-if="is_bath == 0" label="是否特结" name="is_finish" v-model="is_finish" :options="finishNames" required></c-form-item>
				<c-form-item type="datetime" v-model="repayDate" label="还款时间" ></c-form-item>
				<c-form-item type="image" label="还款凭证"  file-word="支持格式：JPG、PNG、GIF等<br>文件大小：不超过5M" v-model="voucherFile"></c-form-item>
				<c-form-item type="textarea" label="还款说明" v-model="repayRemark" ></c-form-item>
			</div>
			</c-form>
		</c-dialog>

		<c-dialog ref="uRepayRecord" :title="'订单（' + orderNumber + '）还款记录'" width="900" height="300">
			<page>
				<module enable-flex>
					<c-table ref="recordTable" :paging="false">
						<c-table-column
							label="还款单号"
							name="repay_number"
							width="130"
						></c-table-column>

						<c-table-column
							label="还款金额"
							name="amount_money"
							width="80"
						>
							<template v-slot="{data}">
								￥{{parseFloat(data.amount_money).toFixed(2)}}
							</template>
						</c-table-column>
						
						<c-table-column
							label="还款凭证"
							name="voucher_file"
							width="80"
						>
							<template v-slot="{data}">
								<c-image v-if="data.voucher_file" :src="data.voucher_file" size="60" preview></c-image>
								<span v-else style="color:#999">--</span>
							</template>
						</c-table-column>
						
						<c-table-column
							label="还款时间"
							name="repay_date"
							width="150"
						></c-table-column>
						
						<c-table-column
							label="还款类型"
							name="is_finish"
							width="80"
						>
							<template v-slot="{data}">
								<span v-if="data.is_finish == 0" >正常还款</span>
								<span v-else style="color:red">特结还款</span>
							</template>
						</c-table-column>
						
						<c-table-column
							label="还款说明"
							name="repay_remark"
							width="100"
						></c-table-column>
						
						<c-table-column
							label="操作人"
							name="repay_user"
							width="100"
						></c-table-column>
						
						<c-table-column
							label="操作时间"
							name="create_date"
							width="150"
						></c-table-column>
					</c-table>
				</module>
			</page>
			
			<template slot="button">
				<c-button size="m" @click="$refs.uRepayRecord.close()">关闭</c-button>
			</template>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_finance_member_credit_detail',
		
		props: {
			tran_state: {
				type: String,
				default: '1'
			},
			exp_flag: String
		},
		
		data() {
			return {
				voucherFile: '',
				text_msg : '',
				repayDate: '',
				is_bath: 0,
				repayMoney: 0,
				is_finish: 0,
				repayRemark: '',
				stateName: {
					0: '未出账',
					1: '待还款',
					2: '已还部分',
					3: '全部还款',
					4: '已取消'
				},
				transState: [{
						name: '未出账(未发货)',
						value: -1
					},{
						name: '待还款',
						value: 1
					},{
						name: '已还部分',
						value: 2
					},{
						name: '已还款',
						value: 3
					},{
						name: '已取消',
						value: 4
					}
				],
				finishNames : [
					{
						name:'正常还款',
						value:'0'
					},
					{
						name:'特结还款',
						value:'1'
					}
				],
				orderNumber: '',
        max_repayMoney:99999999
			}
		},
		
		computed: {
			defaultSearch() {
				return {
					tran_state: this.tran_state ? this.tran_state.split(',') : [],
					exp_flag: this.exp_flag ? this.exp_flag.split(',') : []
				}
			}
		},
		
		watch: {
			defaultSearch(val) {
				this.$refs.searchForm.set(val);
				this.$nextTick(() => {
					this.$refs.search.search();
				})
			}
		},
		
		mounted() {
			this.$refs.searchForm.set(this.defaultSearch);
			this.$nextTick(() => {
				this.$refs.search.search();
			})
		},
		
		methods: {
			searchDetailHandle(data) {
				this.searchDate = data;
				this.$refs.detailTable.load({
					url: '/credit/bill/info/list',
					data
				});
			},
			showRepayRecord(val) {
				this.orderNumber = val.tran_number;
				let data = {};
				data.order_number = val.tran_number;
				this.$refs.recordTable.load({
            url: '/credit/bill/repay/list',
            data
				});
				this.$refs.uRepayRecord.open();
			},
			exportData() {
				var data = this.searchDate;
				data.job_id = 38;
				data.ids = Array.from(this.$refs.detailTable.getRow('selected'), item => item.data.id);
				this.request({
					url: '/export_job/add',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '账单导出任务提交成功，请稍后前往任务中心查看'
						});
					}
				});
				
			},
			onHk(data) {
				var total_money = (data.tran_amount - data.refund_amount - data.return_amount - data.repay_amount);
				var text_msg = `确定要对账单【<font style="font-size:15px;color:red;">${data.tran_number}</font>】执行还款操作吗？<br><br>(还款金额:<font style="font-size:20px;color:red;">￥${parseFloat(total_money).toFixed(2)}</font>，如确定还款，请选择实际还款时间及相关凭证)`;
				this.is_bath = 0;
				this.is_finish = 0;
				this.$refs.repayForm.set({is_finish:0});
				this.repayMoney = (parseFloat(total_money) || 0).toFixed(2);
				this.max_repayMoney = total_money;
				this.openHk(text_msg,[data.id],total_money);
			},
			batchHk() {
				this.is_bath = 1;
				var selectDatas = this.$refs.detailTable.getRow('selected');
				var is_flag = true;
				if (!selectDatas.length) {
					stop();
					this.$message({
						text: '请选择需要还款的账单'
					});
					return;
				}
				
				var total_money = 0;
				selectDatas.forEach(item => {
					if(item.data.tran_state !=1 && item.data.tran_state !=2){
						is_flag = false;
					}else{
						total_money += (item.data.tran_amount - item.data.refund_amount - item.data.return_amount - item.data.repay_amount);
					}
				});
				
				if(!is_flag){
					this.$message({
						text: '只能选择【待还款】的订单进行批量还款操作！'
					});
					return;
				}
				var bill_ids = Array.from(selectDatas, item => item.data.id);
				var text_msg = `确定要对已选的【<font style="font-size:15px;color:red;">${selectDatas.length}笔</font>】账单执行还款操作吗？<br><br>(还款总金额:<font style="font-size:20px;color:red;">￥${parseFloat(total_money).toFixed(2)}</font>，如确定还款，请选择实际还款时间及相关凭证)`;
				this.openHk(text_msg,bill_ids,total_money);
				
			},
			uploadVoucherHandle() {
				this.uploadFile({
					fileType: 'image',
					success: data => {
						this.voucherFile = data.filePath;
					}
				});
			},
			openHk(text_msg,bill_ids,total_money){
				this.text_msg = text_msg;
				this.bill_ids = bill_ids;
				this.total_money = total_money;
				this.voucherFile ='';
				this.repayRemark = '';
				this.repayDate = new Date().format('yyyy-MM-dd hh:mm:ss');
				this.$refs.voucherConf.open();
			},
			submitHk(stop){
				stop();
				if (!this.repayDate) {
					this.$message({
						text: '请选择还款时间'
					});
					return;
				}
				// if (!this.voucherFile) {
				// 	this.$message({
				// 		text: '请上传还款凭证'
				// 	});
				// 	return;
				// }
				
				if(this.is_bath == 0){
					if (!this.repayMoney) {
						this.$message({
							text: '请输入还款金额'
						});
						return;
					}
					if (this.repayMoney > this.max_repayMoney) {
						this.$message({
							text: '还款金额不允许高于待还金额'
						});
						return;
					}
					this.total_money = this.repayMoney;
				}
				this.request({
					url: '/credit/bill/repay',
					data: {
						is_bath: this.is_bath,
						bill_ids: this.bill_ids,
						total_money: this.total_money,
						voucher_file: this.voucherFile,
						repay_date: this.repayDate,
						is_finish: this.is_finish,
						repay_remark: this.repayRemark
					},
					loading: true,
					success: data => {
						this.$message({
							text: '还款成功'
						});
						this.$refs.detailTable.update();
						this.$refs.voucherConf.close();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.payment {
		box-sizing: border-box;
		padding: 5 5px;
		
		p {
			margin-bottom: 18px;
			font-size: 15px;
			font-weight: bold;
			
			span {
				font-size: 13px;
				font-weight: normal;
				color: #999;
				
				a {
					color: #00A8E3;
				}
			}
		}
		
		.voucher {
			height: 220px;
			margin-top: 15px;
			background: #F9F9F9;
			font-size: 20px;
			color: #aaa;
			cursor: pointer;
			
			.tf {
				margin-right: 5px;
				font-size: 28px;
			}
		}
	}
</style>